import {
  getSupportedLocaleOptions,
  setLocale
} from '@/utility/localization';

import { useAuthContext } from '@/contexts/AuthContext';

import PopOverModal from '@/components/common/PopOverModal';
import Icon from '@/components/npl/Icon';

import useLocale from '@/hooks/useLocale';

const LanguageSelectorBottomSheet = ({ open, onClose }) => {
  const { currentLocale } = useLocale();
  const { updateUserLocale } = useAuthContext();

  return (
    <PopOverModal showCloseIcon={false} open={open} onClose={onClose}>
      <div>
        <div className="flex items-center space-x-12 px-8 py-12">
          <button onClick={onClose}>
            <Icon
              name="arrow-left"
              width={16}
              height={16}
              fillOpacity={0.65}
            />
          </button>
          <span className="text-label-lg font-semibold text-npl-text-icon-on-light-surface-primary">
            Language
          </span>
        </div>

        <div className="-mx-16 my-12 border-t-1 border-npl-neutral-light-solid-6" />
        <div>
          {getSupportedLocaleOptions().map((option) => (
            <div
              key={option.value}
              role="button"
              tabIndex={0}
              onClick={async () => {
                await updateUserLocale(option.value);
                setLocale(option.value);
              }}
              className="flex px-8 py-14 text-label-lg text-[#1b1b1b]">
              <span>{option.label}</span>
              {currentLocale === option.value && (
                <Icon
                  name="check"
                  className="ml-auto"
                  width={16}
                  height={16}
                  fillOpacity={0.65}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </PopOverModal>
  );
};

export default LanguageSelectorBottomSheet;
